import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

import { usePublicLanguage } from './i18n/LanguageContext';
import { LANGUAGES } from './i18n/translations';
import backgroundImage from '../../assets/images/hyroc/landing-background.jpg';
import patraNiagaLogo from '../../assets/images/hyroc/pertamina-patra-niaga.png';

// Pendaftaran mitra ditangani aplikasi lain (D-27). Sengaja ditulis sebagai
// konstanta di sini, bukan di `config.js`, karena bukan endpoint yang berpindah
// per lingkungan — alamatnya sama di dev maupun production.
const REGISTRATION_URL = 'https://apps.pertamina.com/dmut_tob';

/**
 * Halaman `/` — landing HYROC (D-26).
 *
 * Sebelumnya `/` langsung menampilkan daftar pengumuman. Sekarang daftar itu
 * hanya di `/tender-announcement`, dan halaman ini menjadi pintu masuknya.
 *
 * Sengaja TIDAK memakai PublicLayout: layout itu membawa navbar, footer, dan
 * latar ombak halaman login, sedangkan rancangan landing memakai foto penuh
 * layar tanpa kerangka apa pun.
 */
const HyrocLanding = () => {
  const { language, setLanguage, t } = usePublicLanguage();

  useEffect(() => {
    document.title = t('landing.documentTitle');
  }, [t]);

  useEffect(() => {
    document.documentElement.setAttribute('lang', language);
  }, [language]);

  return (
    <div
      className='hyroc-landing'
      style={{ backgroundImage: `url(${backgroundImage})` }}
    >
      <div className='hyroc-landing__scrim' aria-hidden='true' />

      <header className='hyroc-landing__topbar'>
        <img
          src={patraNiagaLogo}
          alt={t('landing.logoAlt')}
          className='hyroc-landing__logo'
        />

        <div
          className='hyroc-landing__lang'
          role='group'
          aria-label={t('layout.language')}
        >
          {LANGUAGES.map(item => (
            <button
              key={item.code}
              type='button'
              className={`hyroc-landing__lang-btn ${
                language === item.code ? 'is-active' : ''
              }`}
              onClick={() => setLanguage(item.code)}
              aria-pressed={language === item.code}
            >
              {item.short}
            </button>
          ))}
        </div>
      </header>

      <main className='hyroc-landing__content'>
        <h1 className='hyroc-landing__wordmark'>HYROC</h1>
        <p className='hyroc-landing__tagline'>{t('landing.tagline')}</p>

        <Link to='/tender-announcement' className='hyroc-landing__announcement'>
          {t('landing.announcement')}
          <i className='ri-arrow-right-up-line' aria-hidden='true' />
        </Link>

        <div className='hyroc-landing__actions'>
          <Link
            to='/login'
            className='hyroc-landing__btn hyroc-landing__btn--ghost'
          >
            {t('landing.login')}
          </Link>

          {/* Keluar dari aplikasi ini, jadi <a> biasa — bukan <Link>.
              rel="noopener noreferrer" wajib untuk target="_blank". */}
          <a
            href={REGISTRATION_URL}
            target='_blank'
            rel='noopener noreferrer'
            className='hyroc-landing__btn hyroc-landing__btn--solid'
          >
            {t('landing.registration')}
          </a>
        </div>
      </main>
    </div>
  );
};

export default HyrocLanding;
